import React from 'react';
import { createRoot } from 'react-dom/client';

import './styles.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Auth0Provider } from '@auth0/auth0-react';
import { initDB } from './utils/indexedDb';
import { AUTH_CONFIG } from './auth0-config';
import curateURL from './utils/curateURL';
// AG Grid module registration for Infinite Row Model
import { ModuleRegistry, InfiniteRowModelModule } from 'ag-grid-community';

// Ensure Infinite Row Model is available
ModuleRegistry.registerModules([InfiniteRowModelModule]);

initDB();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <Auth0Provider
    domain={AUTH_CONFIG.domain as string}
    clientId={AUTH_CONFIG.clientId as string}
    authorizationParams={{
      redirect_uri: `${curateURL(AUTH_CONFIG.callbackUrl)}`,
    }}
    // TODO: check if any harm to leave for prod deployment
    // this is for cypress
    cacheLocation="localstorage"
  >
    <App />
  </Auth0Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
